/**
 * Error Handling Object
 */
var plekerror = {

    toastr_messages: 0, //Total toastr messages that are displayed now.
    /**
     * Resets the toastr to the default settings
     */
    reset_toastr() {
        try {
            this.set_toastr(); //Set the toastr with the default values
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * 
     * @param {int} timeOut The duration the notification should be shown. 0 = infinite
     * @param {bool} closeButton If the close button should be shown
     * @param {string} positionClass The position class. Options: https://codeseven.github.io/toastr/demo.html
     */
    set_toastr(timeOut = 0, closeButton = true, positionClass = 'toast-top-right', onCloseClick = null) {
        try {
            toastr.options = {
                "closeButton": closeButton,
                "debug": false,
                "newestOnTop": false,
                "progressBar": false,
                "positionClass": positionClass,
                "preventDuplicates": true,
                "onclick": null,
                "showDuration": "7000",
                "hideDuration": 10,
                "timeOut": timeOut,
                "extendedTimeOut": "0",
                "showEasing": "swing",
                "hideEasing": "linear",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut",
                "fadeOut": 10,
                "onCloseClick": onCloseClick
            }
        } catch (error) {
            console.log(error);
        }
    },

    /**
     * Displays the error message to a field or shows a toastr error message
     * 
     * @param {string} field ID of the field. Null or empty if not field error
     * @param {string} message The Error to display
     * @param {string} title The title of the message. This will only be shown, if not field is present with the given id
     */
    display_error(field, message, title = '') {

        if (jQuery('#' + field).length > 0) {
            //Error is field error
            this.add_error_to_field(field, message);
        } else {
            //Show error as toastr if no field found
            plekerror.toastr_messages++;
            if (plekerror.toastr_messages < 200) {
                toastr.error(message, title);
            } else {
                console.error('Maximum toastr threshold reached');
            }
        }
        console.error(message);
    },

    /**
     * Displays the errors from an ajax response
     * 
     * @param {string|object} response The response from the plekvetica ajax request
     * @param {string} form The form ID
     * @param {bool} display_unassigned_as_toastr If the unassigned errors should be displayed as a toastr message. Default is true
     */
    show_errors_from_response(response, form, display_unassigned_as_toastr = true) {
        if (!plek_main.is_valid_JSON(response)) {
            this.display_error('', __('Oh no! There was an error. Please try it again', 'plekvetica'), __('Invalid response', 'plekvetica'));
            console.error(response);
            return false;
        }

        const encoded_data = JSON.parse(response);

        if (empty(encoded_data.error)) {
            return false;
        }

        //Loop all the fields
        for (const [field_id, errors] of Object.entries(encoded_data.error)) {

            if (typeof errors === "string") {
                //Random error message without assigned field
                this.display_error(false, errors, __('Error', 'plekvetica'));
                continue;
            }

            //Errors is an array / object and most likely there is a field_id existing
            this.show_errors_from_array(field_id, errors, display_unassigned_as_toastr);
        }

        //Show message that there are errors
        if (empty(document.getElementById('toast-container'))) {
            this.display_error(null, __('The form contains errors, please fix them', 'plekvetica'), __('Error', 'plekvetica'));
        }
        return;
    },

    /**
     * Shows all the errors for a given field_name and error object.
     * 
     * @param {string} field_name The id or name of the field
     * @param {object} error_obj The object containing the errors
     * @param {bool} display_unassigned_as_toastr If the unassigned errors should be displayed as a toastr message. Default is true
     */
    show_errors_from_array(field_name, error_obj, display_unassigned_as_toastr = true) {
        if (typeof error_obj !== "object") {
            console.error("No valid Object given", error_obj);
            return;
        }
        const field_element = this.find_element_to_add_error(field_name);
        if (field_element === false) {
            //Field not found
            if (display_unassigned_as_toastr) {
                const msg = (!empty(field_name)) ? field_name + ': ' + error_obj : error_obj;
                this.display_error(false, msg, __('Error', 'plekvetica'))
            } else {
                console.log('No field found with the name: ' + field_name);
            }
        } else {
            //The field exists
            //Check if the field is empty. If it is not an input, empty will not work. Therefore check for innerHTML as well
            if (empty(field_element) && empty(field_element.innerHTML)) {
                if (display_unassigned_as_toastr) {
                    const msg = (!empty(field_name)) ? field_name + ': ' + error_obj : error_obj;
                    this.display_error(false, msg, __('Error', 'plekvetica'))
                } else {
                    console.error("Error messages not displayed", this.get_all_errors_of_field(error_obj));
                }
                return;
            }
        }

        //Show the errors for the field
        this.display_all_errors_of_field(field_element, error_obj)
        return;
    },

    /**
     * Finds the element to add the error message to.
     * 
     * If the given field_name is an ID, it will return the element with that ID.
     * If the given field_name is the name of a field, it will return the parent element of the last element with that name.
     * 
     * @param {string} field_name The id or name of the field
     * @returns {HTMLElement} The element where the error should be added or false when no field is found
     */
    find_element_to_add_error(field_name) {
        //Element found with ID
        const element_id = document.getElementById(field_name);
        if (!empty(element_id)) {
            return element_id;
        }
        const element_name = document.querySelectorAll('input[name="' + field_name + '[]"]');
        if (!empty(element_name)) {
            const lastInput = document.querySelectorAll('input[name="' + field_name + '[]"]')[document.querySelectorAll('input[name="' + field_name + '[]"]').length - 1];
            return lastInput.parentElement;
        }
        const element_name_s = document.querySelectorAll('input[name="' + field_name + '"]');
        if (!empty(element_name_s)) {
            const lastInputS = document.querySelectorAll('input[name="' + field_name + '"]')[document.querySelectorAll('input[name="' + field_name + '"]').length - 1];
            return lastInputS.parentElement;
        }
        return false;

    },

    /**
     * Adds all the errors from the given object to the given field element.
     * 
     * @param {HTMLElement} field_element The element to add the errors to
     * @param {object} errors The object containing the errors. The keys of the object are the keys of the errors, the values are the actual error messages.
     * 
     * @returns {undefined} No return value is expected from this function.
     */
    display_all_errors_of_field(field_element, errors) {
        for (const [index, err] of Object.entries(errors)) {
            this.add_error_to_field(field_element, err);
        }
    },

    /**
    * Displays a fatal error message to the user.
    *
    * @param {object} - An jQuery ajax response
    * @return {undefined} No return value is expected from this function.
    */
    display_fatal_error(data) {
        console.log(data.status, data.statusText, data.responseText);
        if (data.status === 0 && data.statusText === 'error' && typeof data.responseText === 'undefined') {
            return; //Skip the output, because it is no error but a unfinished ajax request
        }
        this.display_error(null, __('There was a critical server error. Please notify the site admin if this error persists. <a href="mailto:">%s</a>', 'plekvetica').replace('%s', 'info@plekvetica.ch'), __('Oh nooo!', 'plekvetica'));
    },

    /**
     * Displays the error message from the spotify api request
     * @param {*} data XMLHttpRequest
     */
    display_spotify_error_message(data) {
        try {
            let response = JSON.parse(data.responseText);
            //Try to format the error
            var message = response.error.message;
            switch (message) {
                case 'invalid id':
                    message = __('Could not find the artist. Please check the ID or URL again', 'plekvetica');
                    break;
                case 'The access token expired':
                    message = __('The Spotify function does not work at the moment. Please try again later', 'plekvetica');
                    break;

                default:
                    break;
            }
            plekerror.display_error('', message, __('Spotify request error', 'plekvetica'));
        } catch (error) {
            console.log(error);
            console.error(data);
        }
    },

    /**
     * Displays a toastr info
     * 
     * @param {string} title The title to display
     * @param {string} message The message to show
     */
    display_info(title, message) {
        if (empty(message)) {
            message = title;
            title = '';
        }
        toastr.info(message, title);
    },

    /**
     * Displays a toastr success / green message
     * 
     * @param {string} title The title to display
     * @param {string} message The message to show
     */
    display_success(title, message) {
        toastr.success(message, title);
    },

    /**
     * Adds a message below the input field as a plek-field-error
     * @param {string} field The Field ID
     * @param {string} message The message to display
     */
    add_error_to_field(field, message) {
        //Check if message does not exist
        let ele = '';
        if (typeof field !== 'string') {
            ele = jQuery(field);
            field = (!empty(ele[0])) ? ele[0].name : '';
        } else {
            ele = jQuery('#' + field);
        }
        const existing_errors = ele.parent().find('.plek-field-error');
        const error_message_formated = `<div id='plek-field-error-${field}' class='plek-field-error'>${message}</div>`;

        if (empty(existing_errors)) {
            ele.parent().append(error_message_formated);
            return;
        }
        //There are some errors. Check to not add a duplicate
        var error_found = false;
        existing_errors.each((index, err) => {
            const msg = jQuery(err).text();
            if (msg === message) {
                error_found = true;
                return; //Skip this item if the message already exists
            }
        });
        if (!error_found) {
            ele.parent().append(error_message_formated);
        }
    },

    scroll_to_first_error() {
        const header = document.querySelector('header');
        const adminbar = document.getElementById('wpadminbar');
        const header_height = (!empty(header)) ? header.getBoundingClientRect().height : 0;
        const admin_height = (!empty(adminbar)) ? adminbar.getBoundingClientRect().height : 0;

        const errors = document.querySelectorAll('.plek-field-error');
        if (empty(errors[0])) {
            return;
        }
        const first_error = errors[0];

        const rect = first_error.getBoundingClientRect();
        const targetPosition = Math.floor(rect.top + window.scrollY - admin_height - header_height);
        jQuery('html, body').animate({
            scrollTop: targetPosition
        }, {
            duration: 500,
            easing: 'swing'
        });
    },

    /**
     * Clears all the field errors and removes all the toastr messages.
     * @returns {undefined} No return value is expected from this function.
     */
    clear_field_errors() {
        jQuery('.plek-field-error').remove();
        toastr.clear();
        return;
    },

    /**
     * Removes a field error of an input. Expects the ID of the Input field.
     * @param {string} field 
     */
    clear_field_error(field) {
        if (jQuery("#plek-field-error-" + field).length === 1) {
            jQuery("#plek-field-error-" + field).remove();
        }
    }
}

plekerror.set_toastr(); //Set the toastr to the default values